var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgId = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_81_922)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.09369 3.03662H5.25244V6.96365H6.09369C6.5576 6.96365 6.93525 6.60084 6.93525 6.15522V3.84521C6.93525 3.39943 6.5576 3.03662 6.09369 3.03662Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.125 0.3125H1.875C1.01203 0.3125 0.3125 1.01203 0.3125 1.875V8.125C0.3125 8.98797 1.01203 9.6875 1.875 9.6875H8.125C8.98797 9.6875 9.6875 8.98797 9.6875 8.125V1.875C9.6875 1.01203 8.98797 0.3125 8.125 0.3125ZM3.59375 7.65625H2.96875V2.34375H3.59375V7.65625ZM7.65625 6.15516C7.65634 6.35628 7.61446 6.55521 7.53328 6.73922C7.45399 6.91872 7.34023 7.0809 7.19844 7.21656C7.05484 7.35435 6.88632 7.46354 6.70187 7.53828C6.50872 7.61661 6.30218 7.65667 6.09375 7.65625H4.53125V2.34375H6.09375C6.30438 2.34375 6.50891 2.38344 6.70203 2.46156C6.88797 2.53719 7.05516 2.64531 7.19859 2.78328C7.34203 2.92125 7.45453 3.08203 7.53344 3.26031C7.61448 3.44464 7.6563 3.6438 7.65625 3.84516V6.15516Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_81_922"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgId);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ID.09082c5326c85b3dd03ee166e7ccc0b5.svg";